import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-password-error',
  templateUrl: './password-error.component.html',
  styleUrl: './password-error.component.scss',
  standalone: false,
})
export class PasswordErrorComponent {
  @Input() control: AbstractControl | undefined;

  public passwordRequirementsNotMet(control: AbstractControl | undefined) {
    if (!control) {
      return false;
    }
    const hasPasswordError =
      control.hasError('missingUpperCase') ||
      control.hasError('missingLowerCase') ||
      control.hasError('missingNumber') ||
      control.hasError('missingSpecialCharacter') ||
      control.hasError('minLength');
    return hasPasswordError && control.dirty;
  }

  public hasError(error: string) {
    return this.control?.hasError(error);
  }
}
